import { useEffect } from "react";

interface SeoInput {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath: string;
  ogType?: string;
  image?: string;
}

const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const buildUrl = (path: string) => {
  const base = String(__BASE_PATH__ || "/").replace(/\/$/, "");
  return `${window.location.origin}${base}${path}`;
};

export default function useSeo({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = "website",
  image,
}: SeoInput) {
  useEffect(() => {
    const url = buildUrl(canonicalPath);
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index,follow,max-image-preview:large");
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("property", "og:site_name", "独家爆料");
    if (image) upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (image) upsertMeta("name", "twitter:image", image);
    upsertCanonical(url);
  }, [title, description, keywords, canonicalPath, ogType, image]);
}